import { isDesktop } from "react-device-detect";
import { DesktopPage } from "./DesktopPage";
import { MobilePage } from "./MobilePage";

export const WelcomePage = ({ onFinish, onGeoBlock }) => {
  return (
    <>{isDesktop ? <DesktopPage /> : <MobilePage onFinish={onFinish} />}</>
  );
};
